import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { ERequestType } from "../../Enum/ERequestType"
import { GetRequest, PostRequest } from "../../services/ApiClientService"

export interface ServicePointSelfServiceSession {
  token: string
  servicePointId: number
  servicePointName: string
  canCreateOrders: boolean
}

export const usePublicServicePointSelfService = () => {
  const { t } = useTranslation("servicePointSelfService")

  const { setError } = useError()

  const storeSession = (session: ServicePointSelfServiceSession) => {
    localStorage.setItem(API_ROUTES.TOKEN_SERVICE_POINT_SELF_SERVICE, session.token)
  }

  const handleValidateStoredSession = async (storeSlug: string) => {
    if (!localStorage.getItem(API_ROUTES.TOKEN_SERVICE_POINT_SELF_SERVICE)) {
      return null
    }

    try {
      const response = await GetRequest<ServicePointSelfServiceSession>(
        API_ROUTES.SERVICE_POINT.GET_SELF_SERVICE_SESSION(storeSlug),
        ERequestType.ServicePointSelfService,
      )

      if (!response.success || !response.data) {
        localStorage.removeItem(API_ROUTES.TOKEN_SERVICE_POINT_SELF_SERVICE)
        return null
      }

      storeSession(response.data)
      return response.data
    } catch {
      localStorage.removeItem(API_ROUTES.TOKEN_SERVICE_POINT_SELF_SERVICE)
      return null
    }
  }

  const handleActivateTablet = async (storeSlug: string, activationCode: string) => {
    try {
      const response = await PostRequest<ServicePointSelfServiceSession>(
        API_ROUTES.SERVICE_POINT.ACTIVATE_SELF_SERVICE(storeSlug),
        { activationCode },
      )

      if (!response.success || !response.data) {
        throw new Error(response.message)
      }

      storeSession(response.data)
      return response.data
    } catch (error) {
      setError(t("error_title"), error instanceof Error ? error.message : t("activation_error"))
      return null
    }
  }

  return {
    handleActivateTablet,
    handleValidateStoredSession,
  }
}
